<template>
<svg xmlns="http://www.w3.org/2000/svg" :fill="useCurrentColor ? 'currentColor' : '#000'" viewBox="0 0 48 48" :class="[`${prefix}-icon`, `${prefix}-icon-Details`]" width="1em" height="1em" v-bind="$attrs"><defs><clipPath id="svg_f26225bde6__a"><rect width="48" height="48" rx="0"/></clipPath></defs><g clip-path="url(#svg_f26225bde6__a)"><path d="M24,5C34.4934,5,43,13.50657,43,24C43,34.4934,34.4934,43,24,43C13.50657,43,5,34.4934,5,24C5,13.50657,13.50657,5,24,5ZM24,8.25714C15.3056,8.25714,8.25714,15.3056,8.25714,24C8.25714,32.6944,15.3056,39.7429,24,39.7429C32.6944,39.7429,39.7429,32.6944,39.7429,24C39.7429,15.3056,32.6944,8.25714,24,8.25714ZM24.5429,29.4286C25.4432,29.4273,26.1737,30.1568,26.1737,31.0571C26.1737,31.9575,25.4432,32.687,24.5429,32.6857C23.6434,32.6857,22.9143,31.9566,22.9143,31.0571C22.9143,30.1577,23.6434,29.4286,24.5429,29.4286ZM24.5429,13.14286C26.0097,13.1429,27.1685,14.3875,27.0639,15.8506L26.2876,26.7186C26.2229,27.6345,25.4611,28.3445,24.5429,28.3445C23.6247,28.3445,22.8628,27.6345,22.7981,26.7186L22.0218,15.8506C21.9173,14.38745,23.076,13.14286,24.5429,13.14286Z"/></g></svg>
</template>
<script>

export default {
  name: 'IconDetails',
  props: {
    prefix: {
        type: String,
        default: 'cmstopgpt',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
